// Ayudas puras de la presentación «Bandeja» (2026-10-06). Sin React: se prueban solas.

/** Colores de avatar: sobrios, sin rosados. Siempre el mismo para la misma persona. */
const PALETA = [`#2563eb`, `#0891b2`, `#059669`, `#65a30d`, `#d97706`, `#7c3aed`, `#475569`, `#0f766e`, `#b45309`, `#4338ca`];

export function colorDe(semilla) {
  let h = 0;
  for (const ch of String(semilla ?? ``)) h = (h * 31 + ch.codePointAt(0)) >>> 0;
  return PALETA[h % PALETA.length];
}

/** «Claudia Chumpitaz» → «CC»; «+51 987…» → «#»; emojis fuera. */
export function iniciales(nombre) {
  const limpio = String(nombre ?? ``).replace(/[^\p{L}\p{N}\s]/gu, ``).trim();
  if (!limpio || /^\d/.test(limpio)) return `#`;
  const partes = limpio.split(/\s+/);
  return (partes[0][0] + (partes[1]?.[0] ?? ``)).toUpperCase();
}

const MIN = 60_000;
const HORA = 60 * MIN;
const DIA = 24 * HORA;

/** «ahora», «5 min», «3 h», «2 d». */
export function haceCuanto(fecha, ahora = new Date()) {
  if (!fecha) return ``;
  const ms = ahora - new Date(fecha);
  if (ms < MIN) return `ahora`;
  if (ms < HORA) return `${Math.floor(ms / MIN)} min`;
  if (ms < DIA) return `${Math.floor(ms / HORA)} h`;
  return `${Math.floor(ms / DIA)} d`;
}

/** Qué tan atrasada está una respuesta: '' | 'tarde' (>2 h) | 'muy-tarde' (>24 h). */
export function atraso(fecha, ahora = new Date()) {
  if (!fecha) return ``;
  const ms = ahora - new Date(fecha);
  return ms > DIA ? `muy-tarde` : ms > 2 * HORA ? `tarde` : ``;
}

function inicioDia(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; }

/** Sección de la lista: Hoy / Ayer / Esta semana / Anteriores. */
export function seccionDe(fecha, ahora = new Date()) {
  if (!fecha) return `Anteriores`;
  const dias = Math.round((inicioDia(ahora) - inicioDia(fecha)) / DIA);
  if (dias <= 0) return `Hoy`;
  if (dias === 1) return `Ayer`;
  if (dias < 7) return `Esta semana`;
  return `Anteriores`;
}

/** Separador del hilo: «Hoy», «Ayer» o «lunes 5 de octubre». */
export function etiquetaDia(fecha, ahora = new Date()) {
  const s = seccionDe(fecha, ahora);
  if (s === `Hoy` || s === `Ayer`) return s;
  return new Date(fecha).toLocaleDateString(`es-PE`, { weekday: `long`, day: `numeric`, month: `long` });
}

export const horaDe = (fecha) =>
  new Date(fecha).toLocaleTimeString(`es-PE`, { hour: `2-digit`, minute: `2-digit`, hour12: false });

/**
 * Agrupa los mensajes en días y, dentro de cada día, en tandas: mensajes
 * seguidos de la misma persona con menos de 5 minutos entre uno y otro.
 * @returns [{ dia, tandas: [{ deMi, autor, desde, mensajes }] }]
 */
export function agruparHilo(mensajes, ahora = new Date()) {
  const dias = [];
  for (const m of mensajes) {
    const dia = etiquetaDia(m.enviadoEn, ahora);
    let d = dias.at(-1);
    if (!d || d.dia !== dia) { d = { dia, tandas: [] }; dias.push(d); }
    const t = d.tandas.at(-1);
    const misma = t && t.deMi === m.deMi && (t.autor ?? null) === (m.autor ?? null)
      && new Date(m.enviadoEn) - new Date(t.mensajes.at(-1).enviadoEn) < 5 * MIN;
    if (misma) t.mensajes.push(m);
    else d.tandas.push({ deMi: m.deMi, autor: m.autor ?? null, desde: m.enviadoEn, mensajes: [m] });
  }
  return dias;
}

/** Nombres repetidos en la lista: a esos se les muestra el final del número. */
export function nombresRepetidos(chats) {
  const vistos = new Map();
  for (const c of chats ?? []) vistos.set(c.nombre, (vistos.get(c.nombre) ?? 0) + 1);
  return new Set([...vistos].filter(([, n]) => n > 1).map(([nombre]) => nombre));
}

export const finDeNumero = (numero) => (numero ? `···${numero.replace(/\D/g, ``).slice(-4)}` : ``);
